import Joi from '@hapi/joi';
import { UpdateHelpInfoParams } from 'types';
import validate from './validate';

export const schema = Joi.object<Partial<UpdateHelpInfoParams>>({
  longMessage: Joi.string().required().messages({
    'string.empty': 'REQUIRED_FIELD',
  }),
  situationsIDs: Joi.array().required().min(1).message('REQUIRED_FIELD'),
  serviceTypeIDs: Joi.array().required().min(1).message('REQUIRED_FIELD'),
});

export default function (value: Partial<UpdateHelpInfoParams>) {
  return validate(schema, value, {
    allowUnknown: true,
    context: {},
  });
}
